<template>
  <div class="ag-page_alertcs position-relative">
    <ag-card :module="module"></ag-card>
  </div>
</template>

<script>
import { computed, defineAsyncComponent, defineComponent, ref } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import PolicyChangeChecklist from "@/helpers/pages/PolicyChangeChecklist";
import api from "@/store/axiosAgsc";
import moment from "moment";
import { orderBy } from "lodash";
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useRoute } from "vue-router";
import dateOptions from "@/helpers/DateOptions";
import { Roles } from "@/helpers/enums/Roles";

export default defineComponent({
  name: "PolicyChangeChecklist",
  setup() {
    const route = useRoute();
    const module = ref(PolicyChangeChecklist);
    const store = useStore();

    const user = computed(() => store.getters.loggedInUser);
    const group = computed(() => store.getters.group);

    const setFilterStatus = () => {
      store.dispatch(GeneralActionTypes.FILTER_STATUS, false);
    };

    let filter = ref({
      page: 1,
      limit: 5,
      riskLevel: null,
      permissionLevel: null,
      startDate: moment().utc().subtract(7, "days").format("YYYY-MM-DDTHH:mm:ss.SSS"),
      endDate: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS"),
      status: 2,
      groupIds: "",
    });

    let permissionLevels, riskLevels, reviewStatuses;

    const getData = async () => {
      await store
        .dispatch(GeneralActionTypes.GET_PERMISSION_LEVELS, null)
        .then((response) => {
          permissionLevels = response;
        });

      await store
        .dispatch(GeneralActionTypes.GET_RISK_LEVELS, null)
        .then((response) => {
          riskLevels = response;
        });

      await store
        .dispatch(GeneralActionTypes.GET_REVIEW_STATUSES, null)
        .then((response) => {
          reviewStatuses = response;
        });
    };

    getData();

    const RESETFILTER = filter;
    const getList = async (
      filters = filter.value,
      options = module.value.component.options
    ) => {
      let currentStatus;

      await store
        .dispatch(GeneralActionTypes.GET_REVIEW_STATUSES, null)
        .then((response) => {
          reviewStatuses = response;
        });

      switch (route.meta.title) {
        case "draftreviews":
          currentStatus = reviewStatuses?.filter((i) => {
            return i.key == "Draft";
          })[0].value;
          break;

        case "completed":
          currentStatus = reviewStatuses?.filter((i) => {
            return i.key == "Complete";
          })[0].value;
          break;

        case "deleted":
          currentStatus = reviewStatuses?.filter((i) => {
            return i.key == "Delete";
          })[0].value;
          break;
      }

      filters.status = currentStatus;
      const body = { filters, options };

      store.dispatch(GeneralActionTypes.GET_POLICY_CHECK_LIST, body);
    };

    const searchWithFilters = (param) => {
      filter.value.page = module.value.component.options.page || 0;
      filter.value.limit = module.value.component.options.pageSize || 5;

      if (user.value.role == Roles.GroupAdmin) {
        filter.value.groupIds = group.value.key == "" ? "" : group.value.key;
      }
      filter.value.groupIds = module.value.filter.filters[0].vmodel || "";

      filter.value.endDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSS");
      filter.value.startDate = moment()
        .startOf("day")
        .subtract(7, "days")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss.SSS");

      if (!param) {
        const findDate = module.value.filter.filters.find(
          (f) => f.param == "range"
        );

        if (findDate && findDate.vmodel) {
          if (typeof findDate.vmodel === "object" && findDate.vmodel.start) {
            filter.value.endDate = moment(findDate.vmodel.end).utc().format(
              "YYYY-MM-DDTHH:mm:ss.SSS"
            );
            filter.value.startDate = moment(findDate.vmodel.start).utc().format(
              "YYYY-MM-DDTHH:mm:ss.SSS"
            );
          } else {
            filter.value.startDate = findDate.vmodel;
          }
        }
      }

      const filters = filter.value;
      const options = module.value.component.options;
      options.page = 1;
      module.value.readyToUseFilters = filters;
      getList(filters, options);
    };

    const resetFilters = () => {
      module.value.filter.filters.forEach((item) => {
        if (item.param == "range") {
          item.vmodel = dateOptions[2].value;
          item.selectedLabel = dateOptions[2].label;
        } else {
          item.vmodel = null;
        }
      });
      searchWithFilters(true);
    };

    return {
      setFilterStatus,
      searchWithFilters,
      resetFilters,
      filter,
      getList,
      module,
    };
  },
  mounted() {
    this.setFilterStatus();
    const filters = this.filter;
    this.module.readyToUseFilters = filters;
    const options = this.module.component.options;
    this.getList(filters, options);
  },
  components: { AgCard },
  watch: {
    "$route.meta.title"(newValue, oldValue) {
      this.setFilterStatus();
      const filters = this.filter;
      this.module.readyToUseFilters = filters;
      const options = this.module.component.options;
      this.getList(filters, options);
    },
  },
});
</script>

<style>
.ag-card_buttons {
  align-items: center;
}
.ag-card_buttons .ag-button {
  height: 37px;
  background: #164b6c;
}

.policy-risk-card {
  border-radius: 0 !important;
  font-size: smaller !important;
}
.risklevel {
  width: 100%;
  border-radius: 15px;
  text-align: center;
  display: block !important;
  padding: 5px 0;
  font-size: 15px;
  color: white;
  max-width: 100px;
}

.risklevel.low {
  background-color: #c3cf8b;
}

.risklevel.medium {
  background-color: #ffc562;
}

.risklevel.high {
  background-color: #d1461c;
}
</style>
